import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AppointmentComponent } from './components/appointment/appointment.component';
import { BookingDetailsComponent } from './pages/booking-details/booking-details.component';
import { PageNotFoundComponent } from './pages/page-not-found/page-not-found.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { BookingComponent } from './pages/booking/booking.component';
import { TermsConditionsComponent } from './pages/terms-conditions/terms-conditions.component';
import { RefundPolicyComponent } from './pages/refund-policy/refund-policy.component';
import { PrivacyPolicyComponent } from './pages/privacy-policy/privacy-policy.component';
import { TrackAppointmentComponent } from './pages/track-appointment/track-appointment.component';
import { BookingStatusComponent } from './pages/booking-status/booking-status.component';
import { FormComponent } from './pages/form/form.component';
import { RescheduleAppointmentComponent } from './pages/reschedule-appointment/reschedule-appointment.component';
import { OfflineBookingComponent } from './pages/offline-booking/offline-booking.component';
import { EditFormComponent } from './pages/edit-form/edit-form.component';
import { FormSuccessComponent } from './pages/form-success/form-success.component';
import { DoctorsListComponent } from './pages/doctors-list/doctors-list.component';
import { BookingListComponent } from './pages/booking-list/booking-list.component';
import { LoginPageComponent } from './pages/login-page/login-page.component';
import { SignUpComponent } from './pages/sign-up/sign-up.component';
import { AuthGuard } from './guards/auth.guard';
import { SpecialtiesComponent } from './pages/specialties/specialties.component';
import { DoctorsComponent } from './pages/doctors/doctors.component';
import { ProfileComponent } from './pages/profile/profile.component';
import { HomeComponent } from './pages/home/home.component';
import { BranchesComponent } from './pages/branches/branches.component';
import { AboutComponent } from './pages/about/about.component';
import { ContactComponent } from './pages/contact/contact.component';
import { FaqComponent } from './pages/faq/faq.component';
import { AiBookingComponent } from './pages/ai-booking/ai-booking.component';


const routes: Routes = [
  { path: '', component: DashboardComponent },
  { path: 'home', component: HomeComponent },
  { path: 'about', component: AboutComponent },
  { path: 'dashboard', component: DashboardComponent },
  { path: 'contact', component: ContactComponent },
  { path: 'faq', component: FaqComponent },
  { path: 'ai-booking', component: AiBookingComponent },
  { path: 'booking/:id', component: BookingComponent },
  { path: 'doctors', component: DoctorsListComponent },
  { path: 'doctors/:branchId', component: DoctorsListComponent },
  { path: 'doctors', component: DoctorsListComponent, data: { hospitalId: '', branchId: '', specialtyId: '', searchTerm: '' } },
{ path: 'doctors/:specialtyId', component: DoctorsListComponent },
  { path: 'doctor-list', component: DoctorsComponent },
  { path: 'doctor-list', component: DoctorsListComponent, data: { hospitalId: '', branchId: '', specialtyId: '', searchTerm: '' } },
  { path: ':hospitalId/branches', component: BranchesComponent },
  { path: 'specialities', component: SpecialtiesComponent },
  { path: 'specialities/:hospitalId', component: SpecialtiesComponent },
  { path: 'appointment', component: AppointmentComponent, canActivate: [AuthGuard] },
  { path: 'booking-list/booking-details/:bookingNumber', component: BookingDetailsComponent, canActivate: [AuthGuard] },
  { path: 'refund-policy', component: RefundPolicyComponent },
  { path: 'privacy-policy', component: PrivacyPolicyComponent },
  { path: 'terms-conditions', component: TermsConditionsComponent },
  { path: 'track-appointment', component: TrackAppointmentComponent, canActivate: [AuthGuard] },
  { path: 'booking-list', component: BookingListComponent, canActivate: [AuthGuard]},
  { path: 'booking-status/:isSuccess', component: BookingStatusComponent },
  { path: 'form', component: FormComponent },
  { path: 'reschedule-appointment', component: RescheduleAppointmentComponent,canActivate: [AuthGuard] },
  { path: 'offline-booking/:token', component: OfflineBookingComponent },
  { path: 'edit-form', component: EditFormComponent },
  { path: 'form-success', component: FormSuccessComponent },
  { path: 'login', component:  LoginPageComponent},
  { path: 'sign-up', component:  SignUpComponent},
  { path: 'profile', component:  ProfileComponent},
  { path: '**', component: PageNotFoundComponent },

];

@NgModule({
  // imports: [RouterModule.forRoot(routes)],
  imports: [RouterModule.forRoot(routes, {
    scrollPositionRestoration: 'top', // Scroll to the top when navigating
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
